module.exports = __webpack_public_path__ + "static/img/logo.eff404c.png";


//////////////////
// WEBPACK FOOTER
// ./src/admin/assets/img/header/logo.png
// module id = dvxP
// module chunks = 15